import React, { Fragment } from 'react';

function QuestionLongAnswer({
  onChange,
  questionId = '',
  value = '',
  name = '',
  label = '',
  autoFocus = true,
}) {
  return (
    <Fragment>
      {label && (
        <label htmlFor={'input-' + questionId} className="form__text-label">
          {label}
        </label>
      )}
      <textarea
        id={'input-' + questionId}
        name={name}
        onChange={onChange}
        value={value || ''}
        autoFocus={autoFocus}
      />
    </Fragment>
  );
}

export default QuestionLongAnswer;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionLongAnswer.js